import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { CommentsSort } from "@defs/types";
import { ISuggestion } from "@defs/suggestion";
import commentsStateHelper from "@helpers/comments-state-helper";

interface CommentsState {
  filter: string;
  sort: CommentsSort;
  suggestions: {
    loading: boolean;
    users: ISuggestion[];
  };
}

const initialState: CommentsState = {
  filter: "ticket",
  sort: "desc",
  suggestions: {
    loading: false,
    users: [],
  },
};

const commentsSlice = createSlice({
  name: "comments",
  initialState,
  reducers: {
    setSort(state, action: PayloadAction<CommentsSort>) {
      state.sort = action.payload;
    },

    setFilter(state, action: PayloadAction<string>) {
      state.filter = action.payload;
    },

    resetSuggestions(state) {
      state.suggestions = initialState.suggestions;
    },
  },
  extraReducers: {
    "comment/suggestion/pending": (state) => {
      state.suggestions.loading = true;
    },

    "comment/suggestion/fulfilled": (
      state,
      action: PayloadAction<ISuggestion[]>
    ) => {
      state.suggestions.loading = false;
      state.suggestions.users = action.payload;
    },

    "ticket/detail/pending": (state) => {
      const value = commentsStateHelper.getSortValueFromLocalstorage();

      if (value) {
        state.sort = value;
      }
    },

    "task/detail/pending": (state) => {
      const value = commentsStateHelper.getSortValueFromLocalstorage();

      if (value) {
        state.sort = value;
      }
    },
  },
});

export const commentsActions = commentsSlice.actions;

export default commentsSlice.reducer;
